export default theme => ({
  root: {
    backgroundColor: '#EEE',
    height: '100vh',
    //backgroundImage: 'url(/images/fondo-gris.jpg)',
  },
  grid: {
    height: '100%',
  },
  beta:{
    color:"white",
    paddingLeft:"10px"
  },
  textWhite:{
    color:"#333",
  },
  gridFooter: {
    paddingTop:"15%"
  },
  quoteWrapper: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  titleImg:{
    paddingLeft:"10px"
  },
  quote: {
    backgroundColor: theme.palette.common.neutral,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },
  img: {
    width:"90px",
  },
  imgLeft: {
    width:"90px",
    float:"left"
  },
  flag: {
    width:"25px",
    paddingRight:"2px;",
    float:"left"
  },
  quoteInner: {
    textAlign: 'center',
    flexBasis: '600px'
  },
  quoteText: {
    color: theme.palette.common.white,
    fontWeight: 300,
  /*   background: 'rgba(245, 123, 66, 0.8)' */
    background: 'rgba(55, 0, 0, 0.5)'
  
  },
  name: {
    marginTop: theme.spacing(3),
    color: theme.palette.common.white
  },
  bio: {
    color: theme.palette.common.white
  },
  contentWrapper: {},
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    
  },
  contentHeader: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(5),
    paddingBototm: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  backButton: {},
  logoImage: {
    height: "60px"
  },
  contentBody: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center'
    }
  },
  form: {
    height:"50%",
    paddingLeft: '100px',
    paddingRight: '100px',
    paddingBottom: '125px',
    flexBasis: '700px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  title: {
    marginTop: theme.spacing(3)
  },

  titleLeft: {
    marginTop: theme.spacing(3),
    float:"left",
    color:"#fa7802"
  },
  titleRight: {
    marginTop: theme.spacing(3),
    float:"right"

  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  facebookButton: {
    marginTop: theme.spacing(3),
    width: '100%'
  },
  facebookIcon: {
    marginRight: theme.spacing(1)
  },
  googleButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  googleIcon: {
    marginRight: theme.spacing(1)
  },
  sugestion: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2),
    //marginLeft:"155px"
  },
  fields: {
    marginTop: theme.spacing(2)
  },
  textField: {
    width: '255px',
    borderRadius:"3px",
    backgroundColor:"white",
    '& + & ': {
      marginTop: theme.spacing(2)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  policyText: {
    display: 'inline',
    color: theme.palette.text.secondary
  },
  policyUrl: {
    color: theme.palette.text.primary,
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.main
    }
  },
  progress: {
    display: 'block',
    marginTop: theme.spacing(2),
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  signInButton: {
    marginTop: theme.spacing(2),
    width: '312px',
    backgroundColor:"#f77520 !important"

  },
  divisor:{
    width:"20%",
  },
  signUp: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary
  },
  signUpUrl: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  fieldError: {
    color: "white",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1)
  },
  submitError: {
    color:"white",
    alignText: 'center',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  snackContent: {
    backgroundColor: theme.palette.error.dark,
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 20,
    lineHeight: 1.3,
    textAlign: 'left',
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(2),
    flexShrink: 0,
  },
  iconStore: {
    height:"50%",
    paddingLeft: '16%',
    paddingRight: '100px',
    paddingBottom: '125px',
    flexBasis: '700px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  iconFlag: {
    height:"20%",
    paddingLeft: '40%',
    paddingRight: '100px',
    paddingBottom: '125px',
    flexBasis: '700px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  iconIn:{height:"44px", fill:"white", width:"30px"},
  divIcon:{
    width:"54px", height:"54px", backgroundColor:"#3b3534", border:"2px solid white", borderRadius:"3px"
  }
});
